import { g as generateUtilityClass } from './styled-722a6242.js';

function generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
  const result = {};
  slots.forEach(slot => {
    result[slot] = generateUtilityClass(componentName, slot, globalStatePrefix);
  });
  return result;
}

export { generateUtilityClasses as g };
//# sourceMappingURL=generateUtilityClasses-06dec860.js.map
